import React, { useEffect, useState } from 'react';
import Sidebar from 'pages/sideBar/SideBar';
import { CiSearch } from "react-icons/ci";
import Invoice from 'components/invoice/Invoice';
import Skeleton from '@mui/material/Skeleton';
import '../app.css';
import './invoice.css';
import imgReviews from '../../../../assets/images/invoice.png';
import axios from 'axios';
import PopupInvoice from 'pages/clientDashbaord/popupinovie/popupInvoice';
import NoDataImage from '../../../../assets/images/nodataImg.png';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components';

function InvoicePage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [displayCount, setDisplayCount] = useState(15);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('');
  const navigate = useNavigate();

  const fetchData = async () => {
    const token = localStorage.getItem('accessToken');
    const apiUrl = 'https://backend.washta.com/api/seller/order';

    try {
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(response.data.data);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        localStorage.clear();
        navigate('/');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  // Custom ID function: WAS-2026-9883A1
  const formatOrderId = (item) => {
    if (!item?._id || !item?.date) return item?._id;
    const year = new Date(item.date).getFullYear();
    const lastSix = item._id.slice(-6).toUpperCase();
    return `WAS-${year}-${lastSix}`;
  };

  const handleDetailsClick = (invoice) => {
    setSelectedInvoice(invoice);
    setModalOpen(true);
  };

  const filteredData = data
    ?.filter(item => item.billingStatus !== "non-paid")
    ?.filter(item => {
      const customId = formatOrderId(item).toLowerCase();
      const lowerSearch = searchTerm.toLowerCase();
      const customerName = item.customerId?.fullName?.toLowerCase() || '';
      
      const matchesSearch = customId.includes(lowerSearch) || customerName.includes(lowerSearch);
      const matchesStatus = statusFilter === "" || item.status === statusFilter;
      
      let matchesDate = true;
      if (dateFilter) {
        const itemDate = item.date?.split('T')[0];
        matchesDate = itemDate === dateFilter;
      }

      return matchesSearch && matchesStatus && matchesDate;
    });

  return (
    <div className='mainDiv-all-sideBar'>
      <div className='div-sidebar'>
        <Sidebar />
      </div>
      <div className='div-Dashbaord'>
        <div className='main-inove-div-search'>
          <h1 className='h1-all-heading'>Invoices</h1>
          
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {/* Status Filter */}
            <select 
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className='invoice-search-icon-div'
              style={{ width: '130px', cursor: 'pointer' }}
            >
              <option value="">All Status</option>
              <option value="ongoing">Ongoing</option>
              <option value="completed">Completed</option>
              <option value="pending">Pending</option>
            </select>

            
            <input 
  type="date"
  value={dateFilter}
  onChange={(e) => setDateFilter(e.target.value)}
  className='invoice-search-icon-div'
  style={{ 
    width: '140px', 
    borderRadius: '15px',
    cursor: 'pointer',
    fontSize: '13px',
    color: '#666',
    border: '1px solid #e0e0e0',
    padding: '5px 10px',
    backgroundColor: '#fdfdfd',
    transition: 'all 0.3s ease',
    outline: 'none'
  }}
  onFocus={(e) => e.target.style.borderColor = '#747eef'}
  onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
/>

            {/* Search Input */}
            <div className='icon-postion-div-inoice' style={{ margin: 0 }}>
              <input
                placeholder='Search ID or Name'
                className='invoice-search-icon-div'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <CiSearch style={{ position: 'absolute', right: 10, top: '22%', fontSize: 18 }} />
            </div>
          </div>
        </div>

        <div className="dashboard">
          <div className='styles-div' style={{ width: '100%' }}>
            <div className='invoice-border'>
              <div className='chart-colm-div-heading'>
                <img src={imgReviews} style={{ width: '1.4em', objectFit: 'contain' }} alt="icon" />
                <h2 className='main-heading2'>History</h2>
              </div>

              {loading ? (
                Array.from(new Array(6)).map((_, index) => (
                  <div key={index} style={{ background: '#747eef9c', padding: '10px 20px', display: 'flex', alignItems: 'center', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px' }}>
                    <Skeleton variant="rectangular" width={48} height={48} style={{ marginRight: '10px', borderRadius: '8px', background: '#747eef9c' }} />
                    <div style={{ flexGrow: 1 }}>
                      <Skeleton variant="text" width="50%" height={30} style={{ marginBottom: '5px', background: '#f1f2fd' }} />
                      <Skeleton style={{ background: '#f1f2fd' }} variant="text" width="30%" height={20} />
                    </div>
                  </div>
                ))
              ) : filteredData.length === 0 ? (
                <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                  <img src={NoDataImage} alt="No Data" style={{ maxWidth: '50%', maxHeight: '50%', objectFit: 'contain' }} />
                </div>
              ) : (
                filteredData.slice(0, displayCount).map((item) => (
                  <div key={item._id} style={{ paddingBottom: 15 }}>
                    <Invoice
                      buttonClick={() => handleDetailsClick(item)}
                      date={item?.date?.split('T')[0]}
                      textInvoice={formatOrderId(item)} // Rendering as WAS-2026-9883A1
                      btnPurple='Delete'
                      btnTranspraent='Details'
                    />
                  </div>
                ))
              )}

              {displayCount < filteredData.length && (
                <div className='flex justify-center'>
                  <Button onClick={() => setDisplayCount(displayCount + 20)} className='text-[10px] w-[20%] h-[10%] mt-3'>
                    View More
                  </Button>
                </div>
              )}

              <PopupInvoice isOpen={modalOpen} onClose={() => setModalOpen(false)} data={selectedInvoice} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvoicePage;